export const MixedAirlineKey = "Mixed Airline";

export const AircraftUnknown = "Unknown";
